import { AccordionDetails, Grid, Typography } from '@material-ui/core';
import { FC, ReactElement } from 'react';

import {
  IClientAllocationDetailed,
  ILocationGroupClient,
} from '~/services/api/clientAllocation/types';
import { IClientOption, IClientOptionByTeam } from '~/store/client/types';
import { AllocationMode } from '../../../../constants/allocationMode';
import AccordionMemberGroupForm from './AccordionMemberGroupForm';
import AllocationMemberClientForm from './AllocationMemberClientForm';

import styles from '../../AccordionMembers.module.scss';

interface IProps {
  allocationMode: AllocationMode;
  selectedClients: IClientOption[];
  selectedClientsByLocationGroup: Record<string, ILocationGroupClient[]>;
  renderSelect: () => ReactElement;
  handleRemoveClient: (id: number, field: string) => void;
  formFieldName: string;
  watchedClients: number[];
  isGlobalUser: boolean;
  memberId: number;
  handleRemoveClientInLocationGroup: (id: number, field: string, groupName?: string) => void;
  validateAvailability?: boolean;
  clientAllocationsList?: IClientAllocationDetailed[];
}

const AccordionMembersDetailsFields: FC<IProps> = ({
  allocationMode,
  selectedClientsByLocationGroup,
  selectedClients,
  renderSelect,
  handleRemoveClient,
  handleRemoveClientInLocationGroup,
  formFieldName,
  watchedClients,
  isGlobalUser,
  memberId,
  validateAvailability,
  clientAllocationsList,
}) => (
  <AccordionDetails>
    <Grid container>
      <Grid item sm={12} className={styles.accordionDetailsContainer}>
        {renderSelect()}
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      <Grid item sm={12}>
        {selectedClients.length ? (
          <Typography variant="subtitle1" className={styles.assignedClientsTitle}>
            Assigned Clients
          </Typography>
        ) : null}
        {allocationMode === AllocationMode.BY_LOCATION_GROUP ? (
          <AccordionMemberGroupForm
            selectedClientsByLocationGroup={selectedClientsByLocationGroup}
            handleRemoveClientInLocationGroup={handleRemoveClientInLocationGroup}
            watchedClients={watchedClients}
            formFieldName={formFieldName}
            isGlobalUser={isGlobalUser}
            memberId={memberId}
          />
        ) : (
          selectedClients.map((client, index) => {
            const currentAllocationClient =
              clientAllocationsList.length > 1
                ? clientAllocationsList?.[index]
                : clientAllocationsList?.[0];

            const memoFieldName = currentAllocationClient?.id
              ? `_${memberId}_${currentAllocationClient.id}`
              : `_${memberId}`;

            return (
              <AllocationMemberClientForm
                validateAvailability={validateAvailability}
                key={client.id}
                clientName={client.name}
                clientPhoto={client.photo}
                isGlobalUser={isGlobalUser}
                teams={
                  (client as IClientOptionByTeam).teams?.length > 0
                    ? (client as IClientOptionByTeam).teams
                    : undefined
                }
                clientId={client.id}
                fieldNameMemberId={formFieldName}
                memoFieldName={memoFieldName}
                handleRemoveClient={handleRemoveClient}
                memberId={memberId}
                resolved={!!currentAllocationClient?.resolved}
              />
            );
          })
        )}
      </Grid>
    </Grid>
  </AccordionDetails>
);

export default AccordionMembersDetailsFields;
